import Grid from '@mui/material/Grid/Grid'
import placeholder from '/assets/Image/moment-card-placeholder.png'
import placeholderBlock from '/assets/Image/moment-card-placeholder-block.png'

const PlaceholderCard = () => {
  return (
    <div
      className={`min-w-[70%] !p-[6px] sm:min-w-[40%] md:min-w-[25%] lg:min-w-[16%] `}
    >
      <div className={`card-moment h-full`}>
        <div className={`flex h-full flex-col rounded-[10px] bg-black1 p-6`}>
          <img src={placeholder} alt="" className="aspect-square" />
          <div
            className={`z-10 mb-6 flex min-h-[96px] flex-col justify-center gap-2 py-6`}
          >
            <img src={placeholderBlock} alt="" className="h-[18px]" />
            <img src={placeholderBlock} alt="" className="h-[18px]" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PlaceholderCard
